/**
 * Express log level (Same of big logger)
 */
export enum LogLevel {
  LOG_ALL = 0,
  LOG_INFO = 1,
  LOG_WARNING = 5,
  LOG_ERROR = 10,
  LOG_NONE = 99,
}
